import DatePicker from 'antd/lib/date-picker';

export default DatePicker;
